import { UserService } from 'src/app/services/user/user.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, Params, NavigationExtras } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AppService } from 'src/app/services/general/app.service';
import { LinkService } from 'src/app/services/general/link.service';
import { Subscription } from 'rxjs';
import { User } from 'src/app/interfaces/user';
import { AppRateService } from 'src/app/services/general/app-rate.service';

@Component({
  selector: 'app-app-rating',
  templateUrl: './app-rating.page.html',
  styleUrls: ['./app-rating.page.scss'],
})
export class AppRatingPage implements OnInit, OnDestroy {

  showMenuBtn: boolean;

  showPage: boolean;

  iosApp: boolean;

  private promptRating: boolean;

  private backHelpPage: boolean;

  private userSubscription: Subscription;

  constructor(
    private platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private appService: AppService,
    private appRateService: AppRateService,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
    this.unwatchUser();
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (state?.showPage === 'true' || state?.showPage === true) {
        this.showPage = true;
      } else if (param?.showPage === 'true' || param?.showPage === true) {
        this.showPage = true;
      } else {
        this.showPage = false;
      }

      if (param.backHelpPage) {
        this.backHelpPage = true;
      } else if (route?.extras?.state?.backHelpPage) {
        this.backHelpPage = true;
      } else {
        this.backHelpPage = false;
      }
      
      if (state?.promptRating === 'true' || state?.promptRating === true) {
        this.promptRating = true;
      } else if (param?.promptRating === 'true' || param?.promptRating === true) {
        this.promptRating = true;
      } else {
        this.promptRating = false;
      }

      
      if (this.promptRating) {
        this.promptAppRate();
      } else if (!this.showPage) {
        this.goAppRating();
      }
    });
  }

  ionViewWillEnter() {
    this.watchUser();
    this.check();
  }

  ionViewWillLeave() {
    this.unwatchUser();
  }

  /**
   * Watch user
   */
  async watchUser() {
    if (!this.userSubscription) {
      this.userSubscription = this.userService.observableUser.subscribe((user: User) => {
        if (user?.uid) {
          this.showMenuBtn = true;
        }
      });
    }
  }

  /**
   * Unwatch user
   */
  async unwatchUser() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
      this.userSubscription = null;
    }
  }

  check() {
    if (this.platform.is('ios') && this.platform.is('hybrid')) {
      this.iosApp = true;
    }
  }

  async promptAppRate() {
    await this.platform.ready();
    this.appRateService.promptAppRate();
  }

  goBack() {
    if (this.backHelpPage) {
      this.goHelpPage();
    } else {
      this.goMainPage();
    }
  }

  goHelpPage() {
    this.router.navigate(['/about/help']);
  }

  /**
   * Go main page
   */
  goMainPage() {
    this.linkService.goMainPage();
  }

  goContactPage() {
    const navigationExtras: NavigationExtras = {
      state: { backRatingPage: true, backHelpPage: this.backHelpPage }
    };
    this.router.navigate(['/about/contact'], navigationExtras);
  }

  async goAppRating() {
    await this.platform.ready();
    await this.appService.goRating();
    this.showPage = true;
  }

  openGoogleReview() {
    this.appService.openGoogleProfile();
  }

  openFacebookReview() {
    this.appService.openFacebookReview();
  }

  openAppStoreReview() {
    this.appService.openAppStore();
  }

  openPlayStoreReview() {
    this.appService.openPlayStore();
  }

  openAppGalleryReview() {
    this.appService.openAppGallery();
  }

}
